module.exports = __webpack_public_path__ + "img/BuI_pad.8589c171.png";